
import { inject } from '@angular/core';
import { CanActivateFn, Router} from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { MENU_ITEMS } from '../../menu.config';


export const authGuard: CanActivateFn = (route, state) => {

  const router = inject(Router)
  const token = localStorage.getItem('authToken');

  const isTokenExpired = (token: string): boolean => {
    try{
      const payload = JSON.parse(atob(token.split('.')[1]))
      return payload.exp * 1000 < Date.now();
    }
    catch {
      return true;
    }
  }

  if(token && !isTokenExpired(token)) {
    return true;
  }
  // else {
  //   localStorage.setItem('lastVisitedUrl',state.url)
  //   router.navigate(['/login'])
  //   return false;
  // }

  localStorage.removeItem('authToken');
  localStorage.setItem('lastVisitedUrl',state.url);
  router.navigate(['/login']);
  return false;
};

export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isLoggedIn()) {
    return true;
  }

  const role = authService.getRole();
  const firstAllowed = MENU_ITEMS.find(item => item.roles.includes(role));
  const targetRoute = firstAllowed?.route ||
    firstAllowed?.children?.find(child => child.roles.includes(role))?.route ||
    '/essl/employee';

  return router.parseUrl(targetRoute.startsWith('/') ? targetRoute : `/${targetRoute}`);
};
